"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePayPeriodRange = void 0;
const react_query_1 = require("react-query");
const fetchClient_1 = require("../../client/fetchClient");
const paths_1 = require("../../paths");
const EventEmitter_1 = require("../../utils/EventEmitter");
const taaConfigs_1 = require("../../contexts/taaConfigs");
function usePayPeriodRange({ employeeId, startDate, endDate, usageLocation }) {
    const { host, clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const urlProps = { employeeId, startDate, endDate, usageLocation };
    const path = (0, paths_1.GET_PAY_PERIOD_RANGE_API)(urlProps);
    const { isLoading, data: rawResponse } = (0, react_query_1.useQuery)(['payPeriodRange', path], () => (0, fetchClient_1.getData)({
        path,
        host,
        eventName: EventEmitter_1.taaEvents.GET_PAY_PERIOD_RANGE,
        metaData: {
            apiName: 'getPayPeriodRange',
            clientName
        },
        usageLocation
    }, currentStage), {
        enabled: !!employeeId && !!startDate && !!endDate,
        staleTime: 60 * 1000,
        retry: false
    });
    const GetPayPeriodRangeResponse = {
        startTime: rawResponse === null || rawResponse === void 0 ? void 0 : rawResponse.start_time,
        endTime: rawResponse === null || rawResponse === void 0 ? void 0 : rawResponse.end_time,
        workedTimeBreakdown: rawResponse === null || rawResponse === void 0 ? void 0 : rawResponse.total_pay_period,
        timeOffBreakdown: rawResponse === null || rawResponse === void 0 ? void 0 : rawResponse.timeoff_usage,
        unpaidTimeBreakdown: rawResponse === null || rawResponse === void 0 ? void 0 : rawResponse.fc_upt_usage
    };
    return { isLoading, payPeriodRange: GetPayPeriodRangeResponse };
}
exports.usePayPeriodRange = usePayPeriodRange;
